"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListResponseMessageOut = void 0;
class ListResponseMessageOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ListResponseMessageOut.attributeTypeMap;
    }
}
exports.ListResponseMessageOut = ListResponseMessageOut;
ListResponseMessageOut.discriminator = undefined;
ListResponseMessageOut.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<MessageOut>",
        "format": ""
    },
    {
        "name": "done",
        "baseName": "done",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "iterator",
        "baseName": "iterator",
        "type": "string",
        "format": ""
    },
    {
        "name": "prevIterator",
        "baseName": "prevIterator",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=ListResponseMessageOut.js.map